// Svensk formatering av tal och tider, för appen och för händelsernas texter.

import { tidszonensForskjutning } from "./tid.ts";

export function tal(v: number, decimaler = 1): string {
  return v.toLocaleString("sv-SE", {
    minimumFractionDigits: decimaler,
    maximumFractionDigits: decimaler,
  });
}

/**
 * b18: texten som en mening: en punkt på slutet, men aldrig en till när texten redan slutar med
 * en punkt (eller ! ? …), till exempel "under 25 % i mer än 6 timmar." och inte "timmar..".
 */
export function mening(t: string): string {
  const s = t.trimEnd();
  return s === "" || /[.!?…]$/.test(s) ? s : `${s}.`;
}

/** Klockslag i svensk tid, till exempel "14.05". */
export function klockslag(ms: number): string {
  return new Date(ms)
    .toLocaleTimeString("sv-SE", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Europe/Stockholm",
    })
    .replace(":", ".");
}

/** Datum och klockslag, till exempel "17 okt. 14.05". */
export function datumOchTid(ms: number): string {
  const d = new Date(ms).toLocaleDateString("sv-SE", {
    day: "numeric",
    month: "short",
    timeZone: "Europe/Stockholm",
  });
  return `${d} ${klockslag(ms)}`;
}

/** Klockslag i en tidszon, till exempel "18.00". */
export function klockslagI(ms: number, tidszon: string): string {
  return new Date(ms)
    .toLocaleTimeString("sv-SE", { hour: "2-digit", minute: "2-digit", timeZone: tidszon })
    .replace(":", ".");
}

/**
 * Veckodag och klockslag i en tidszon, till exempel "fredag 18.00". Ligger dagen en vecka eller
 * mer fram, så att veckodagen kan betyda två dagar, eller har tiden redan varit, kommer datumet
 * med: "fredag 30 okt. 18.00".
 */
export function dagOchTid(ms: number, tidszon: string, nu: number): string {
  const d = new Date(ms);
  const dag = d.toLocaleDateString("sv-SE", { weekday: "long", timeZone: tidszon });
  const dygn = (t: number) => Math.floor((t + tidszonensForskjutning(t, tidszon)) / 86_400_000);
  const medDatum = dygn(ms) - dygn(nu) >= 7 || ms < nu;
  const datum = medDatum
    ? ` ${d.toLocaleDateString("sv-SE", { day: "numeric", month: "short", timeZone: tidszon })}`
    : "";
  return `${dag}${datum} ${klockslagI(ms, tidszon)}`;
}

/** Hur länge sedan, till exempel "för 3 min sedan". */
export function sedan(ms: number, nu: number): string {
  const s = Math.max(0, Math.round((nu - ms) / 1000));
  if (s < 60) return "nyss";
  const min = Math.round(s / 60);
  if (min < 60) return `för ${min} min sedan`;
  const tim = Math.round(min / 60);
  if (tim < 48) return `för ${tim} tim sedan`;
  return `för ${Math.round(tim / 24)} dygn sedan`;
}
